export const downloadTableModalInitValue = {
  data: {
    pdfFormat: false,
    excelFormat: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangePdfFormat(): void {},
    handleChangeExcelFormat(): void {},
    handleDownloadTable(): void {},
  },
};
